import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { CoreModule } from '@core';
import { SharedModule } from '@shared';

import { MaterialModule } from '@app/material.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';

import { StammdatenComponent } from './stammdaten.component';
import { TatbestandDialogComponent } from './dialog-tatbestand/dialog-tatbestand.component';

import { ButtonModule } from 'primeng/button';
import { MessagesModule } from 'primeng/messages';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MaterialModule,

    TranslateModule,
    //CoreModule,
    //SharedModule,

    MatTableModule,
    MatTabsModule,

    ConfirmDialogModule,
    ButtonModule,
    MessagesModule,
  ],
  providers: [ConfirmationService],
  declarations: [StammdatenComponent, TatbestandDialogComponent],
})
export class StammdatenModule {}
